import type { StackProps } from '@mui/material';

import {
  Section,
  NameBanner,
  CustomizedAccordion,
} from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';
import {
  MainText,
  StyledStack,
  StyledButton,
  DescriptionText,
  StyledTextStack,
  StyledLinkWrapper,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';
import {
  AccordionData,
  ZeroKnowledgeProofDevelopmentServicesData,
} from './ZeroKnowledgeProofDevelopmentServices.data';

export const ZeroKnowledgeProofDevelopmentServices = ({
  ...props
}: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text="Services" color="teal" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              {ZeroKnowledgeProofDevelopmentServicesData.mainText}
            </MainText>
            <DescriptionText variant="strong_400">
              {ZeroKnowledgeProofDevelopmentServicesData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion
              data={AccordionData()}
              CustomButton={
                <StyledLinkWrapper>
                  <StyledButton onClick={() => scrollToElement(contactFormId)}>
                    Book a free consultation
                  </StyledButton>
                </StyledLinkWrapper>
              }
            />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
